// ============================================
// Transfer Page - New Style
// ============================================

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaExchangeAlt, FaHome, FaChartBar, FaEye, FaFileAlt } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import './Transaction.css';

const Transfer = () => {
  const { user, refreshUser } = useAuth();
  const [recipientId, setRecipientId] = useState('');
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const transferAmount = parseFloat(amount);
    if (!transferAmount || transferAmount <= 0) {
      toast.error('กรุณากรอกจำนวนเงินที่ถูกต้อง');
      return;
    }

    if (transferAmount > user.balance) {
      toast.error('ยอดเงินไม่เพียงพอ');
      return;
    }

    if (!recipientId.trim()) {
      toast.error('กรุณากรอก ID ผู้รับ');
      return;
    }

    if (recipientId === user.id) {
      toast.error('ไม่สามารถโอนให้ตัวเองได้');
      return;
    }

    setLoading(true);
    try {
      await api.transfer(recipientId, transferAmount);
      toast.success('โอนเงินสำเร็จ');
      await refreshUser();
      navigate('/profile');
    } catch (error) {
      toast.error(error.message || 'ไม่สามารถโอนเงินได้');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="transaction-page">
      {/* Header */}
      <div className="transaction-header">
        <button className="btn-back" onClick={() => navigate('/profile')}>
          <FaArrowLeft />
        </button>
        <h1>
          <FaExchangeAlt /> โอนเงิน
        </h1>
      </div>

      <div className="transaction-content">
        <div className="transaction-card">
          <div className="info-box">
            <p><strong>💰 ยอดเงินคงเหลือ:</strong> ${user?.balance?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
            <p style={{ marginTop: '8px', fontSize: '13px' }}>💡 โอนเงินให้เพื่อนได้ทันที ไม่มีค่าธรรมเนียม</p>
          </div>

          <form onSubmit={handleSubmit} className="transaction-form">
            <div className="form-group">
              <label>ID ผู้รับ</label>
              <input
                type="text"
                className="input"
                placeholder="กรอก ID ผู้รับ (เช่น ABC123)"
                value={recipientId}
                onChange={(e) => setRecipientId(e.target.value.toUpperCase())}
                disabled={loading}
              />
              <small>ID ของคุณ: {user?.id}</small>
            </div>

            <div className="form-group">
              <label>จำนวนเงิน (USD)</label>
              <input
                type="number"
                className="input"
                placeholder="กรอกจำนวนเงิน"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                disabled={loading}
                min="0.01"
                step="0.01"
              />
            </div>

            <div className="quick-amount-grid">
              <button type="button" onClick={() => setAmount('100')} disabled={loading}>
                $100
              </button>
              <button type="button" onClick={() => setAmount('500')} disabled={loading}>
                $500
              </button>
              <button type="button" onClick={() => setAmount('1000')} disabled={loading}>
                $1,000
              </button>
              <button type="button" onClick={() => setAmount(user?.balance?.toString())} disabled={loading}>
                ทั้งหมด
              </button>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? 'กำลังโอน...' : 'โอนเงิน'}
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Navigation */}
      <nav className="bottom-nav">
        <Link to="/" className="nav-item">
          <FaHome />
          <span>Home</span>
        </Link>
        <Link to="/trading" className="nav-item">
          <FaChartBar />
          <span>Trade</span>
        </Link>
        <Link to="/history" className="nav-item">
          <FaEye />
          <span>History</span>
        </Link>
        <Link to="/profile" className="nav-item">
          <FaFileAlt />
          <span>Profile</span>
        </Link>
      </nav>
    </div>
  );
};

export default Transfer;
